<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <mtc-form-item label="label.accountNumber">
              <!--<a-input placeholder="请输入账号查询" v-model="queryParam.username"></a-input>-->
              <j-input :placeholder="$t('label.pleaseEnterTheAccountNumber')" v-model="queryParam.username"></j-input>
            </mtc-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <mtc-form-item label="label.gender">
              <a-select v-model="queryParam.sex" :placeholder="$t('label.pleaseSelectGender')">
                <a-select-option value="">{{ $t('tip.pleaseSelect') }}</a-select-option>
                <a-select-option value="1">{{ $t('label.male') }}</a-select-option>
                <a-select-option value="2">{{ $t('label.female') }}</a-select-option>
              </a-select>
            </mtc-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <mtc-form-item label="label.realName">
              <a-input :placeholder="$t('label.pleaseEnterRealName')" v-model="queryParam.realname"></a-input>
            </mtc-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <mtc-form-item label="label.cellPhone">
              <a-input :placeholder="$t('label.pleaseEnterCellPhoneNumber')" v-model="queryParam.phone"></a-input>
            </mtc-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <mtc-form-item label="label.userStatus">
              <a-select v-model="queryParam.status" :placeholder="$t('tip.pleaseSelect')">
                <a-select-option value="">{{ $t('tip.pleaseSelect') }}</a-select-option>
                <a-select-option value="1">{{ $t('label.normal') }}</a-select-option>
                <a-select-option value="2">{{ $t('label.block') }}</a-select-option>
              </a-select>
            </mtc-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <BaseTable ref="baseTable"
               @searchReset="searchReset"
               :mainTable="mainTable"
               :advancedSearch="superQueryFieldList"
               :tableColumns="columns"
               :tableData="tableData">
      <!-- 左侧操作按钮 -->
      <template #leftButton>
        <mtc-button class="mg-r8" @click="handleAdd" type="primary" icon="plus" text="button.add" />
        <mtc-button class="mg-r8" @click="handleExportXls('用户信息')" type="primary" icon="download" text="button.export" />
        <a-upload name="file"
                  :showUploadList="false"
                  :multiple="false"
                  :headers="tokenHeader"
                  :action="importExcelUrl"
                  @change="handleImportExcel">
          <mtc-button class="mg-r8" type="primary" icon="import" text="button.import" />
        </a-upload>
        <mtc-button class="mg-r8" @click="recycleBinVisible=true" type="primary" icon="hdd" text="button.recycleBin" />
        <a-dropdown class="mg-r8" v-if="selectedRowKeys.length > 0">
          <a-menu slot="overlay" @click="handleMenuClick">
            <a-menu-item key="1">
              <a-icon type="delete" @click="batchDel" />
              {{ $t('button.delete') }}
            </a-menu-item>
            <a-menu-item key="2">
              <a-icon type="lock" @click="batchFrozen('2')" />
              冻结
            </a-menu-item>
            <a-menu-item key="3">
              <a-icon type="unlock" @click="batchFrozen('1')" />
              解冻
            </a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px">
            {{ $t('button.batchOperation') }}
            <a-icon type="down" />
          </a-button>
        </a-dropdown>
      </template>
      <template slot="avatarslot" slot-scope="{record}">
        <div class="anty-img-wrap">
          <a-avatar shape="square" :src="getAvatarView(record.avatar)" icon="user" />
        </div>
      </template>
      <span slot="action" slot-scope="{record}">
          <!--<a @click="handleEdit(record)" >{{$t('button.edit')}}</a>-->
          <mtc-button @click="handleEdit(record)" type="link" size="small" text="button.edit"></mtc-button>
          <a-divider type="vertical" />
          <a-dropdown>
            <mtc-button type="link" size="small" text="button.more"></mtc-button>
            <a-menu slot="overlay">
              <a-menu-item>
                <!--<a href="javascript:;" @click="handleDetail(record)">{{$t('button.details')}}</a>-->
                <mtc-button @click="handleDetail(record)" type="link" size="small" text="button.details"></mtc-button>
              </a-menu-item>
              <a-menu-item>
                <!--<a href="javascript:;" @click="handleChangePassword(record.username)">密码</a>-->
                <mtc-button @click="handleChangePassword(record.username)" type="link" size="small" text="button.password"></mtc-button>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="$t('tip.isDelete')" @confirm="() => handleDelete(record.id)">
                  <!--<a>{{$t('button.delete')}}</a>-->
                   <mtc-button type="link" size="small" text="button.delete"></mtc-button>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item v-if="record.status==1">
                <a-popconfirm title="确定冻结吗?" @confirm="() => handleFrozen(record.id,2,record.username)">
                  <mtc-button type="link" size="small" text="button.frozen"></mtc-button>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item v-if="record.status==2">
                <a-popconfirm title="确定解冻吗?" @confirm="() => handleFrozen(record.id,1,record.username)">
                  <mtc-button type="link" size="small" text="button.thaw"></mtc-button>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
    </BaseTable>
    <!-- table区域-end -->
    <user-modal ref="modalForm" @ok="modalFormOk" />
    <password-modal ref="passwordmodal" @ok="passwordModalOk" />
    <!-- 用户回收站 -->
    <user-recycle-bin-modal :visible.sync="recycleBinVisible" @ok="modalFormOk" />
  </a-card>
</template>

<script>
import UserModal from './modules/UserModal'
import PasswordModal from './modules/PasswordModal'
import { putAction, getFileAccessHttpUrl } from '@/api/manage'
import { frozenBatch, getUserList } from '@/api/api'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import JInput from '@/components/jeecg/JInput'
import UserRecycleBinModal from './modules/UserRecycleBinModal'
import JSuperQuery from '@/components/jeecg/JSuperQuery'
import { MTC_AUTH } from '@api/servers'
import { BaseTable } from '@comp/mtcModule'

export default {
  name: 'UserList',
  mixins: [JeecgListMixin],
  components: {
    BaseTable,
    UserModal,
    PasswordModal,
    JInput,
    UserRecycleBinModal,
    JSuperQuery
  },
  data() {
    return {
      mainTable: 'sys_user',
      // 列表数据
      tableData: params => this.getData(params),
      //查询条件收起状态
      toggleSearchStatus: true,
      description: '这是用户管理页面',
      queryParam: {},
      recycleBinVisible: false,
      columns: [
        /*{
          title: '#',
          dataIndex: '',
          key:'rowIndex',
          width:60,
          align:"center",
          customRender:function (t,r,index) {
            return parseInt(index)+1;
          }
        },*/
        {
          slotName: 'tableHeader.userAccount',
          // title: '用户账号',
          align: 'center',
          dataIndex: 'username',
          width: 120,
          sorter: true,
          scopedSlots: { title: 'tableHeader.userAccount' }
        },
        {
          slotName: 'tableHeader.userName',
          // title: '用户姓名',
          align: 'center',
          width: 100,
          dataIndex: 'realname',
          scopedSlots: { customRender: 'realname', title: 'tableHeader.userName' }
        },
        {
          slotName: 'tableHeader.image',
          // title: '头像',
          align: 'center',
          width: 120,
          dataIndex: 'avatar',
          scopedSlots: { customRender: 'avatarslot', title: 'tableHeader.image' }
        },
        {
          slotName: 'tableHeader.gender',
          // title: '性别',
          align: 'center',
          width: 80,
          dataIndex: 'sex_dictText',
          sorter: true,
          scopedSlots: { title: 'tableHeader.gender' }
        },
        {
          slotName: 'tableHeader.birthday',
          // title: '生日',
          align: 'center',
          width: 100,
          dataIndex: 'birthday',
          scopedSlots: { title: 'tableHeader.birthday' }
        },
        {
          slotName: 'tableHeader.cellPhone',
          // title: '手机号码',
          align: 'center',
          width: 100,
          dataIndex: 'mobile',
          scopedSlots: { title: 'tableHeader.cellPhone' }
        },
        // {
        //   title: '部门',
        //   align: "center",
        //   width: 180,
        //   dataIndex: 'orgCodeTxt'
        // },
        // {
        //   title: '负责部门',
        //   align: "center",
        //   width: 180,
        //   dataIndex: 'departIds_dictText'
        // },
        {
          slotName: 'tableHeader.status',
          // title: '状态',
          align: 'center',
          width: 80,
          dataIndex: 'status_dictText',
          scopedSlots: { title: 'tableHeader.status' }
        },
        {
          slotName: 'tableHeader.operation',
          // title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action', title: 'tableHeader.operation' },
          align: 'center',
          width: 80
        }
      ],
      superQueryFieldList: [
        { type: 'input', value: 'username', text: this.$t('label.userAccount') },
        { type: 'input', value: 'realname', text: this.$t('label.userName') },
        { type: 'select', value: 'sex', text: this.$t('label.gender'), dictCode: 'sex' }
      ],
      url: {
        syncUser: `${MTC_AUTH}act/process/extActProcess/doSyncUser`,
        list: `${MTC_AUTH}sys/user/list`,
        delete: `${MTC_AUTH}sys/user/delete`,
        deleteBatch: `${MTC_AUTH}sys/user/deleteBatch`,
        exportXlsUrl: `${MTC_AUTH}sys/user/exportXls`,
        importExcelUrl: `${MTC_AUTH}sys/user/importExcel`
      }
    }
  },
  computed: {
    importExcelUrl() {
      return `${window._CONFIG[ 'domianURL' ]}/${this.url.importExcelUrl}`
    }
  },
  methods: {
    modalFormOk() {
      this.$refs.baseTable.refresh()
    },
    // 重置查询条件
    searchReset() {
      this.queryParam = {}
      this.$refs.baseTable.refresh()
    },
    searchQuery() {
      this.$refs.baseTable.refresh()
    },
    getData(baseParams) {
      let params = {
        ...baseParams,
        ...this.queryParam
      }
      return getUserList(params)
    },
    getAvatarView(avatar) {
      return getFileAccessHttpUrl(avatar)
    },
    batchFrozen(status) {
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning(this.$t('tip.pleaseSelectARecord'))
        return false
      } else {
        let ids = ''
        let that = this
        let isAdmin = false
        that.selectionRows.forEach(function(row) {
          if (row.username === 'admin') {
            isAdmin = true
          }
        })
        if (isAdmin) {
          that.$message.warning('管理员账号不允许此操作,请重新选择！')
          return
        }
        that.selectedRowKeys.forEach(function(val) {
          ids += val + ','
        })
        that.$confirm({
          title: '确认操作',
          content: '是否' + (status == 1? '解冻': '冻结') + '选中账号?',
          onOk: function() {
            frozenBatch({ ids: ids, status: status }).then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.loadData()
                that.onClearSelected()
              } else {
                that.$message.warning(res.message)
              }
            })
          }
        })
      }
    },
    handleMenuClick(e) {
      if (e.key == 1) {
        this.batchDel()
      } else if (e.key == 2) {
        this.batchFrozen(2)
      } else if (e.key == 3) {
        this.batchFrozen(1)
      }
    },
    handleFrozen(id, status, username) {
      let that = this
      //TODO 后台校验管理员角色
      if ('admin' == username) {
        that.$message.warning('管理员账号不允许此操作！')
        return
      }
      frozenBatch({ ids: id, status: status }).then((res) => {
        if (res.success) {
          that.$message.success(res.message)
          that.loadData()
        } else {
          that.$message.warning(res.message)
        }
      })
    },
    handleChangePassword(username) {
      this.$refs.passwordmodal.show(username)
    },
    passwordModalOk() {
      //TODO 密码修改完成 不需要刷新页面，可以把datasource中的数据更新一下
    }
  }
}
</script>

<style scoped lang="less">
@import "~@assets/less/common.less";
</style>